export default "__VITE_ASSET__Dkit$qpw__"